import { useClientsStore } from '@/store/clients';

export const contactsOptions = {
    searchClients: async (query: string | Record<string, any> = '') => {
        const store = useClientsStore();
        await store.searchClients(query);
        return store.clients_result;
      },
};
